import type {
  CombinedInstrument,
  CombinedInstrumentChartData,
  CombinedInstrumentListResponse,
  CombinedInstrumentStatistics,
  CombinedInstrumentUsage,
  SaveCombinedInstrumentPayload,
} from "@repo/shared/types";
import { del, get, post, put } from "@/lib/api/_client";

const BASE = "/internal/combined-instruments";

export function list(
  page: number = 1,
  pageSize: number = 20,
): Promise<CombinedInstrumentListResponse> {
  return get(`${BASE}?page=${page}&pageSize=${pageSize}`);
}

export function getById(id: string): Promise<CombinedInstrument> {
  return get(`${BASE}/${id}`);
}

export function create(data: SaveCombinedInstrumentPayload): Promise<CombinedInstrument> {
  return post(BASE, data);
}

export function update(
  id: string,
  data: SaveCombinedInstrumentPayload,
): Promise<CombinedInstrument> {
  return put(`${BASE}/${id}`, data);
}

/** What references this basket — checked before offering to delete it. */
export function getUsage(id: string): Promise<CombinedInstrumentUsage> {
  return get(`${BASE}/${id}/usage`);
}

export function remove(id: string): Promise<CombinedInstrument> {
  return del(`${BASE}/${id}`);
}

export function getStatistics(id: string): Promise<CombinedInstrumentStatistics> {
  return post(`${BASE}/${id}/statistics`);
}

export function getChartData(id: string): Promise<CombinedInstrumentChartData> {
  return post(`${BASE}/${id}/chart-data`);
}
